"use client";

import * as X from "@/ui";
import { useDownloadUrl } from "@/providers/onelink";

import { useDownloadPopup } from "@/providers/strapi/content/types/singleTypes/download-popup";
import ReactMarkdown from "react-markdown";


const InWhiteBox = true as boolean;


export function DownloadModal(props: X.PageProps<{
  isOpen: boolean;
  onClose: () => void;
}>) {

  return (
    <X.Modal onClose={props.onClose} noBackgroundDim={InWhiteBox}>
      {props.isOpen && (
        InWhiteBox ? (
          <div className={X.clsx("relative bg-white/90 px-[140px] py-[130px] rounded-4xl shadow-2xl")}>
            <Content {...props} />

            <X.Icon.X
              onClick={props.onClose}
              className="absolute cursor-pointer p-[6px] w-[36px] h-[36px] top-[40px] right-[40px] text-white bg-black rounded-full"
            />
          </div>

        ) : (
          <Content {...props} />
        )
      )}
    </X.Modal>
  );
}


function Content(props: X.PageProps<{
  isOpen: boolean;
  onClose: () => void;
}>) {
  // const tr = X.useTranslator();
  const downloadUrl = useDownloadUrl(props.locale);
  const downloadPopup = useDownloadPopup('downloadPopup')
  return (
    <div className={X.clsx(
      "bg-yellow rounded-4xl w-2xl p-12 pb-0",
      "flex flex-col relative",
      InWhiteBox && "shadow-xl",
    )}>
      {!InWhiteBox && (
        <X.Icon.X
          onClick={props.onClose}
          className="absolute cursor-pointer p-4 w-[60px] h-[60px] top-4 right-7"
        />
      )}
      <div className="flex flex-row items-center gap-35">
        <div className="flex-grow pb-12">
          <ReactMarkdown components={{
            p: ({ ...props }) => <h3 {...props} className="text-[32px] leading-tight mb-6 [&_strong]:font-medium" />
          }}>
            {downloadPopup.title}
          </ReactMarkdown>
          {/* <h3 className="text-[32px] leading-tight mb-6">
            {tr({
              en: <>Download<br /><strong className="font-medium">the app</strong></>,
              fr: <>Téléchargez<br /><strong className="font-medium">l'application</strong>  </>
            })}
          </h3> */}
          <div className="flex flex-row gap-3 mb-6">
            <X.ExternalLink href={downloadUrl}>
              <X.Image
                // src={tr({ en: AppStoreEn, fr: AppStoreFr, zh: AppStoreEn })}
                src={downloadPopup.appStoreImage.url}
                unoptimized
                width={downloadPopup.appStoreImage.size}
                height={45}

                alt="App Store" className="h-[45px] w-auto" />
            </X.ExternalLink>
            <X.ExternalLink href={downloadUrl}>
              <X.Image
                // src={tr({ en: PlayStoreEn, fr: PlayStoreFr, zh: AppStoreEn })}
                src={downloadPopup.playStoreImage.url}
                width={downloadPopup.playStoreImage.size}
                height={45}
                unoptimized
                alt="Play Store" className="h-[45px] w-auto" />
            </X.ExternalLink>
          </div>
          <ReactMarkdown>
            {downloadPopup.content}
          </ReactMarkdown>
          {/* <p>
            {tr({
              en: "Or scan the QR code with your phone to download Zapptax.",
              fr: "Ou scannez le code QR avec votre téléphone pour télécharger Zapptax.",
            })}
          </p> */}
        </div>

        {downloadUrl && (
          <div className="flex-initial">
            <X.QrCode scale={4} value={downloadUrl} className="invisible" />

            <div className="absolute bottom-0 right-12 p-4 bg-white rounded-t-4xl border-7 border-b-0 border-black">
              <X.QrCode scale={4} value={downloadUrl} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
